import { owlGlobalSession } from "../../../supabase/functions/_shared/owl-window.ts";
import type { League } from "../../leagues/useLeagues.ts";
import type { OwlHourSlip, OwlTier } from "../../owl/useOwlHourSlips.ts";
import { owlActiveRefreshPhase, owlSessionDate } from "../../owl/owlScreenState.ts";
export interface OwlHeroProps {
  leagues: readonly League[];
  slips: readonly OwlHourSlip[];
  selectedTier: OwlTier;
}
export function OwlHero({ slips, selectedTier }: OwlHeroProps): JSX.Element {
  const slip = slips.find((s) => s.tier === selectedTier);
  return (
    <div className="owl-session-bar" aria-label="Session information">
      <div>
        <span>Session</span>
        <strong>{slip?.slip_date ?? owlSessionDate()}</strong>
      </div>
      <div>
        <span>Refresh</span>
        <strong>
          {(slip?.refresh_phase ?? owlActiveRefreshPhase()) === "noon" ? "12:00" : "17:00"} Accra
        </strong>
      </div>
      <div>
        <span>Overnight coverage</span>
        <strong>{owlGlobalSession(slip?.slip_date??owlSessionDate())?"19:00–07:00 Accra":"Through 03:00 Accra"}</strong>
      </div>
      <div>
        <span>Publication</span>
        <strong>
          {slip
            ? slip.status === "settled"
              ? "Settled"
              : slip.meta.reduced_board
                ? "Reduced board"
                : "Published"
            : "Not published"}
        </strong>
      </div>
    </div>
  );
}
